import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Stroke} from '../../../../../Models/Stroke';
import {formatTime} from '../../../../Support/Formatting/formatTime';
import {formatDistance} from '../../../../Support/Formatting/formatDistance';
import {formatStrokeRate} from '../../../../Support/Formatting/formatStrokeRate';
import {formatSplit} from '../../../../Support/Formatting/formatSplit';
import {formatPower} from '../../../../Support/Formatting/formatPower';
import {formatStrokeLength} from '../../../../Support/Formatting/formatStrokeLength';
import {formatEnergy} from '../../../../Support/Formatting/formatEnergy';
import {formatPeakForce} from '../../../../Support/Formatting/formatPeakForce';
import {formatPeakForcePosition} from '../../../../Support/Formatting/formatPeakForcePosition';
import {formatDriveTime} from '../../../../Support/Formatting/formatDriveTime';
import {formatRecoverTime} from '../../../../Support/Formatting/formatRecoverTime';
import {formatPowerSplit} from '../../../../Support/Formatting/formatPowerSplit';
import {Content} from './Components/Content';
import {useSettings, PowerMode} from '../../../../Settings/settings';
import {formatRelativePeakForcePosition} from '../../../../Support/Formatting/formatRelativePeakForcePosition';

interface OwnProps {
    strokes: Stroke[];
}

export const SingleStrokeAnalyzer: FunctionComponent<OwnProps> = ({strokes}) => {
    const [activeStrokeNumber, setActiveStrokeNumber] = useState(1);

    const stroke = strokes[activeStrokeNumber - 1];

    const {powerMode} = useSettings();

    return (
        <>
            <Content
                topBuckets={[
                    {value: formatTime(stroke.totalTime), label: 'Time'},
                    {value: formatDistance(stroke.totalDistance), label: 'Distance'},
                    {value: formatStrokeRate(stroke.strokeRate), label: 'Stroke rate'},
                ]}
                dataBuckets={[
                    {value: formatSplit(stroke.speed), label: 'Split'},
                    {
                        value:
                            powerMode === PowerMode.Split ? formatPowerSplit(stroke.speed) : formatPower(stroke.power),
                        label: powerMode === PowerMode.Split ? 'Split Power' : 'Power',
                    },
                    {value: formatStrokeLength(stroke.strokeLength), label: 'Stroke length'},
                    {value: formatEnergy(stroke.energy), label: 'Energy per stroke'},
                    {value: formatPeakForce(stroke.peakForce), label: 'Peak force'},
                    {value: formatPeakForcePosition(stroke.peakForcePosition), label: 'Peak force position'},
                    {
                        value: formatRelativePeakForcePosition(stroke.relativePeakForcePosition),
                        label: 'Rel. Peak Pos.',
                    },
                    {value: formatDriveTime(stroke.driveTime), label: 'Drive time'},
                    {value: formatRecoverTime(stroke.recoverTime), label: 'Recover time'},
                ]}
                curve={stroke.curve || []}
            />
            <input
                type="range"
                className="form-range"
                value={activeStrokeNumber}
                onChange={(event) => setActiveStrokeNumber(() => parseInt(event.target.value, 10))}
                min={1}
                max={strokes.length}
                step={1}
            />
        </>
    );
};
